import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Typography } from "antd";
import "./zincAdvice.scss";
import ReportHelper from "../../../helpers/report.helper";
import { TestView } from "../testView/testView.component"
import { LowercaseTest, RiskLevel, ReportSection, TestCode } from "../../../enums/index.enum"
import { AdviceSection } from "../adviceSection/adviceSection.component";
import { renderToString } from 'react-dom/server'
import { TestLink } from "../testLink/testLink.component";
import ResultHelper from "../../../helpers/result.helper";
import parse from 'html-react-parser';

const { Paragraph } = Typography;


export const ZincAdvice = ({ report, section, setSectionMeta, user, tests, results, reports }) => {
  const [recs, setRecs] = useState()
  const [riskLevel, setRiskLevel] = useState();
  const [title, setTitle] = useState();
  const [primaryDescription, setPrimaryDescription] = useState();
  const [zincTests, setZincTests] = useState();

  // progress
  const [isFixed, setIsFixed] = useState();
  const [isBetter, setIsBetter] = useState();
  const [isWorse, setIsWorse] = useState();
  const [isStatic, setIsStatic] = useState();

  useEffect(() => {
    setIsFixed(ReportHelper.isFixed(report, ReportSection.ZINC_ADVICE));
    setIsBetter(ReportHelper.isBetter(report, ReportSection.ZINC_ADVICE));
    setIsWorse(ReportHelper.isWorse(report, ReportSection.ZINC_ADVICE));
    setIsStatic(ReportHelper.isStatic(report, ReportSection.ZINC_ADVICE));
  }, [report]);

  useEffect(() => {
    setZincTests(getZincTests())
  }, [report, tests])

  useEffect(() => {
    setTitle(getTitle());
    setPrimaryDescription(getPrimaryDescription())
  }, [riskLevel, report, zincTests])

  useEffect(() => {
    setSectionMeta(sectionMeta => {
      return {
        ...sectionMeta,
        [section.code]: {
          title: renderToString(title),
          primaryDescription: renderToString(primaryDescription),
          recs
        }
      }
    })
  }, [title, primaryDescription, recs])

  useEffect(() => {
    populateTestLinks()
  }, [primaryDescription])

  useEffect(() => {
    setRiskLevel(getRiskLevel())
  }, [tests, results, report])


  const getZincTests = () => {
    if (!report || !tests) return null


    const t = ReportHelper.getSectionTests(report, ReportSection.ZINC_ADVICE, tests)

    return t
  }

  const getRiskLevel = () => {
    if (!tests || !results || !report) return null;
    return ReportHelper.getTestRisk(TestCode.TSH, report, results, tests);
  };

  const getTitle = () => {
    if (report?.lockedAt) return parse(section.meta.title)
      
    if (!report || !riskLevel || !tests || !results) return null;

    

    if (isBetter || isFixed) {
      return <>Your <span>zinc</span> levels are <span>improving</span>.</>
    }

    if (isWorse) {
      return <>Your <span>zinc</span> levels are <span>{ResultHelper.getDirection(TestCode.ZINC, results, tests)}</span>, which puts your immune system at risk.</>

    }

    if (isStatic) {
      return <>Your <span>zinc</span> levels remain <span>unchanged</span>.</>
    }

    return <>
        Your <span>zinc</span> levels are <span>low</span>, which puts your immune system at risk.
    </>
  };

  const getPrimaryDescription = () => {
    if (report?.lockedAt) return parse(section.meta.primaryDescription)

    if (!report || !riskLevel || !tests || !results || !zincTests) return null;

    return (
      <>
        Zinc is essential for keeping your immune system strong, healing wounds, controlling inflammation, and regulating your blood sugar. It also plays a big role in preventing long-term problems like diabetes and heart disease.
        
        <br/><br/>
        Your body can’t store much zinc, so even a small drop in your levels can affect your health more than you might realize. Supplementing now will help you feel better, protect you from infections, and reduce your risk of chronic disease down the line.

      </>
    )
  }


  const populateTestLinks = () => {
    const testLinks = document.getElementsByClassName('view-test')
    for (const testLink of testLinks) {
      const testCode = testLink.id.split('-')[2]
      const test = tests.find(({ code }) => code === Number(testCode))
      ReactDOM.render(
        <TestLink
          test={test}
          content={testLink.getAttribute('text')}
          report={report}
          tests={tests}
          results={results}
          reports={reports} 
        />,
        testLink
      )
    }
  }

  return (
    zincTests && <div className="zinc-advice">
      <Paragraph className="report-template-title">{title}</Paragraph>
      <Paragraph className="report-template-description">{primaryDescription}</Paragraph>

      <TestView
        report={report} 
        tests={zincTests}
        results={results}
        reports={reports}
        user={user}
      />
      <AdviceSection 
        report={report} 
        results={results}
        tests={tests}
        section={section}
        recs={recs}
        setRecs={setRecs}
        reports={reports}
      />
    </div>
  );
};
